import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { dGet } from '@core/utils'
import { Flex } from 'hljd'
import Arrow from '../Common/Arrow'
import { getNoticeGiftHonorTextColor } from '@components/LocalMerchant/Decoration/util'

@observer
export default class extends Component {
  render() {
    const { homeData, newThemeConfig, themeConfig, theme } = this.props.store
    const honorData = dGet(homeData, 'merchant_achievement', []) || []
    const { title, label_img } = honorData[0] || []
    return honorData.length ? (
      <div
        style={{
          padding: '0 16px',
          backgroundColor: newThemeConfig['moduleBg']
        }}
      >
        <Flex
          sp
          vc
          style={{
            borderBottom: `1px solid ${themeConfig['line']}`,
            height: 52
          }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-start',
              alignItems: 'center',
              width: 315,
              overflow: 'hidden'
            }}
          >
            <img
              style={{
                width: 13,
                height: 13,
                margin: '0 9px 0 0'
              }}
              src={newThemeConfig['honorIcon']}
            />
            {label_img && (
              <img
                style={{
                  width: 46,
                  height: 17,
                  margin: '0 9px 0 0'
                }}
                src={label_img}
              />
            )}
            <p
              style={{
                width: 235,
                height: 52,
                lineHeight: '52px',
                fontSize: 15,
                color: getNoticeGiftHonorTextColor(theme),
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
              }}
            >
              {title}
            </p>
          </div>

          <Arrow />
        </Flex>
      </div>
    ) : null
  }
}
